// This is like useState that propagates everything to url params
// Works with react-router-6

import { useEffect, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

const validateKeys = (defaultState, keys) => {
  if (
    Object.keys(defaultState || {}).filter((k) => !keys.includes(k)).length &&
    process.env.NODE_ENV !== "production"
  )
    throw new Error(
      "Please, unsure you've registered all the keys used in the object"
    );
};

export const useSearchParamsState = (
  defaultState: Record<string, string>,
  keys: string[]
) => {
  // Check that default state has only keys passed in keys
  useEffect(() => {
    validateKeys(defaultState, keys);
  }, []);

  const [searchParams, setSearchParams] = useSearchParams(defaultState);

  const objectState = useMemo(() => {
    const params = searchParams;

    const ret = {};
    keys.forEach((k) => (ret[k] = params.get(k)));

    return ret;
  }, [searchParams]);

  const setUrlParams = (newState: Record<string, string>) => {
    validateKeys(newState, keys);

    const newParams = {};

    Object.entries(newState).forEach(([key, value]: [string, string]) => {
      if (Boolean(value) || value === "") newParams[key] = value;
    });

    setSearchParams(newParams, {
      replace: true
    });
  };

  return [objectState, setUrlParams] as [
    Record<string, string>,
    (newState: Record<string, string>) => void | never
  ];
};
